<template>
  <div>
    <v-dialog fullscreen value="true" persistent transition="dialog-bottom-transition">
      <v-card>
        <Toolbar
          :title="`Send a ${wizardLanguage}`"
          :icon="wizardIcon"
          :color="recognitionMode ? 'brandPrimary' : 'systemWalletGreen'"
          :hideClientDropdown="slideKey > keys.review"
          @close="reset"
        />
        <v-row
          class="full-height mt-6 pb-6 container-row"
          justify="center"
          align="start"
          height="100%"
          no-gutters
        >
          <v-col
            cols="11"
            sm="11"
            md="6"
            lg="4"
            xl="3"
            class="main-card rounded-lg px-5 d-flex flex-column justify-space-between"
          >
            <div>
              <div class="d-flex justify-space-between align-center mt-10">
                <pill-nav
                  :steps="pillNavSteps"
                  width="100%"
                  :height="40"
                  :step="slideKey"
                  :value="slideKey > keys.review ? progressBarValue : undefined"
                  color="brandPrimary"
                  class="mr-6"
                  @input="goToSlide"
                >
                </pill-nav>
                <div class="lottie-container">
                  <Button
                    :disabled="disableContinueButton"
                    @click="goToNextSlide"
                    :icon-right="slideKey < keys.review ? 'mdi-arrow-right' : ''"
                    >{{
                      slideKey == keys.sent ? "Close" : slideKey == keys.review ? "Send" : "Next"
                    }}</Button
                  >
                  <!-- <v-btn
                    :width="isMobile ? 90 : 110"
                    rounded
                    depressed
                    color="brandPrimary"
                    class="white--text font-weight-bold"
                    @click="goToNextSlide"
                    :disabled="disableContinueButton"
                  >
                    <span
                      v-if="slideKey !== keys.sent"
                      style="margin-top: 2px"
                      >{{
                        slideKey == keys.sent
                          ? "Close"
                          : slideKey == keys.review
                          ? "Send"
                          : "Next"
                      }}</span
                    >
                    <v-icon
                      color="white"
                      class="mr-1"
                      v-if="slideKey == keys.sent"
                      >mdi-checkbox-marked-circle</v-icon
                    >

                    <v-icon
                      color="white"
                      class="mr-1"
                      v-else-if="!isMobile && slideKey != keys.review"
                      >mdi-arrow-right</v-icon
                    >
                  </v-btn> -->
                  <div v-if="lottie.particle" class="lottie-particle-effect">
                    <LottiePlayer
                      animation="particles"
                      :height="250"
                      :width="250"
                      :speed="1.5"
                      :loop="false"
                    />
                  </div>
                </div>
              </div>

              <!-- </div> -->
              <transition :name="slideDirection" mode="out-in">
                <div
                  v-if="slideKey === keys.recipient"
                  :key="keys.recipient"
                  class="full-width text-left"
                >
                  <Typography variant="h-4" v-if="pageTitle" class="py-6">{{
                    pageTitle
                  }}</Typography>
                  <div class="d-flex align-center flex-wrap">
                    <div
                      v-for="(user, index) in values.selected"
                      :key="user.userId"
                      :style="{ 'max-width': '100%' }"
                    >
                      <v-chip
                        class="ma-1 selected-audience-chip"
                        close
                        outlined
                        color="brandPrimary"
                        @click:close="removeUserFromSelected(index)"
                      >
                        <v-icon
                          @click.stop="loadQrCode(user.groupId)"
                          class="mr-1 cursor-pointer"
                          color="grey"
                          v-if="user.groupId && user.groupType === 'List'"
                          >mdi-qrcode</v-icon
                        >
                        <span class="text-truncate black--text"> {{ user.displayName }}</span>
                      </v-chip>
                    </div>
                  </div>
                  <div class="d-flex justify-space-between align-center mt-10">
                    <v-text-field
                      label="Start typing a name, email, or phone"
                      v-model="data.debounceSearch"
                      outlined
                      flat
                      dense
                      hide-details
                      color="brandPrimary"
                      class="search-field mr-3"
                      @focus="changeSearchTab"
                    >
                    </v-text-field>
                    <v-btn
                      v-if="
                        (data.activeAudienceTab == 2 && canCreateGroup) ||
                        (canCreateUser && data.activeAudienceTab != 2)
                      "
                      fab
                      depressed
                      small
                      color="brandPrimary"
                      @click="
                        if (data.activeAudienceTab == 2) {
                          displayGroupTypeSelector();
                        } else {
                          dialog.createUser = true;
                        }
                      "
                      ><v-icon color="white">{{
                        data.activeAudienceTab == 2
                          ? "mdi-account-multiple-plus"
                          : "mdi-account-plus"
                      }}</v-icon></v-btn
                    >
                  </div>
                  <div
                    v-if="(permissions || []).includes('vue:read:groups')"
                    class="d-flex justify-space-between align-center mt-6"
                    :class="{ 'mx-14': !isMobile }"
                  >
                    <!-- <span
                      @click="changeAudienceTab(0)"
                      class="rounded-pill audience-tab cursor-pointer"
                      :class="{
                        'active-audience-tab': data.activeAudienceTab == 0
                      }"
                      >Recent</span
                    > -->
                    <span
                      @click="changeAudienceTab(1)"
                      class="rounded-pill audience-tab cursor-pointer"
                      :class="{
                        'active-audience-tab': data.activeAudienceTab == 1,
                      }"
                      >People</span
                    >
                    <span
                      @click="changeAudienceTab(2)"
                      class="rounded-pill audience-tab cursor-pointer"
                      :class="{
                        'active-audience-tab': data.activeAudienceTab == 2,
                      }"
                      >Groups</span
                    >
                  </div>
                  <div class="text-left mt-2">
                    <v-divider class="mt-5" />
                    <!-- Table for people -->
                    <div v-if="data.activeAudienceTab <= 1">
                      <UserTable
                        ref="user-table"
                        :selected="selectedUsers"
                        :search="data.search"
                        @select-item="addUserToSelected($event, false)"
                      />
                    </div>
                    <div v-else>
                      <GroupTable
                        ref="group-table"
                        :selected="values.selected"
                        :search="data.search"
                        @select-item="addUserToSelected($event, false)"
                        @update-item="updateSelectedItem"
                      />
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="slideKey === keys.memo"
                  :key="keys.memo"
                  class="full-width text-left"
                >
                  <Typography variant="h-4" v-if="pageTitle" class="py-6">{{
                    pageTitle
                  }}</Typography>

                  <div class="pb-6 d-flex" v-if="canViewAIAssistant || recognitionMode">
                    <template v-if="canViewAIAssistant">
                      <Typography
                        variant="subtitle-1"
                        class="pr-4 d-flex align-center"
                        :key="k"
                        v-for="(v, k) in feedback.vibe"
                      >
                        <v-progress-circular
                          v-if="loading.feedback"
                          color="brandPrimary"
                          indeterminate
                          size="17"
                          width="2"
                          class="mr-1 ml-0 px-0"
                        ></v-progress-circular>
                        <v-badge
                          v-else
                          class="nudge-up ml-4"
                          bottom
                          dot
                          left
                          :color="v ? 'green' : 'grey'"
                        >
                          <span class="hidden" style="font-size: 1px">*</span>
                        </v-badge>
                        {{ capitalize(k) }}
                      </Typography>
                    </template>
                    <Typography variant="subtitle-1" v-else-if="recognitionMode"
                      >Behavior, Feeling, Impact</Typography
                    >
                  </div>
                  <v-textarea
                    :placeholder="
                      recognitionMode
                        ? 'Daniel, I am consistently impressed by your patience with every customer interaction that you face. Your ability to create space for their needs to be heard and calm approach to problem solving allow us to remain a trusted partner to our customers.'
                        : 'Reward memo'
                    "
                    outlined
                    v-model="values.memo"
                    color="brandPrimary"
                  ></v-textarea>
                  <template v-if="canViewAIAssistant">
                    <template v-if="loading.suggestion && computedNote">
                      <div
                        class="d-flex border rounded blue--text pa-2"
                        style="border: 1px solid #2196f3"
                      >
                        <v-avatar class="white pa-1" size="32px">
                          <v-img contain src="@/assets/robin/Curious.png" height="32px" />
                        </v-avatar>
                        <typing />
                      </div>
                    </template>
                    <template v-else-if="feedback.recommendation">
                      <div class="border rounded blue--text pa-2" style="border: 1px solid #2196f3">
                        <div class="d-flex flex-column">
                          <p>{{ feedback.recommendation }}</p>
                          <div class="d-flex justify-space-between">
                            <div class="d-flex justify-start">
                              <v-avatar class="white pa-1" size="32px">
                                <v-img contain src="@/assets/robin/Curious.png" height="32px" />
                              </v-avatar>
                            </div>
                            <div class="d-flex justify-space-between">
                              <v-btn
                                outlined
                                rounded
                                class="mx-2"
                                small
                                color="blue"
                                :disabled="loading.feedback"
                                @click="aiRecommendation"
                                >Try Again</v-btn
                              >
                              <v-btn
                                outlined
                                rounded
                                class="mx-2"
                                small
                                color="blue"
                                @click="
                                  (values.memo = feedback.recommendation),
                                    (feedback.recommendation = null)
                                "
                                >Use this</v-btn
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <v-btn
                        color="blue"
                        :disabled="!computedNote || loading.feedback || feedback.initialLoad"
                        :loading="loading.suggestion"
                        outlined
                        @click="aiRecommendation"
                      >
                        <v-avatar class="white pa-1" size="32px">
                          <v-img contain src="@/assets/robin/Curious.png" height="32px" />
                        </v-avatar>
                        Improve my Recognition
                      </v-btn>
                    </template>
                  </template>
                  <div v-if="recognitionMode">
                    <div class="d-flex align-center pt-6">
                      <Typography variant="h-4">Visibility</Typography>
                      <v-tooltip top
                        ><template v-slot:activator="{ on, attrs }"
                          ><v-icon v-on="on" v-bind="attrs" class="ml-3"
                            >mdi-help-circle-outline</v-icon
                          ></template
                        ><Typography variant="body-2"
                          >A public recognition will be displayed company-wide in the Activity
                          Feed</Typography
                        ></v-tooltip
                      >
                    </div>
                    <v-radio-group row v-model="values.visibility"
                      ><v-radio value="PRIVATE" label="Private" color="brandPrimary"></v-radio
                      ><v-radio value="PUBLIC" label="Public" color="brandPrimary"></v-radio
                    ></v-radio-group>
                  </div>
                </div>
                <div
                  v-else-if="slideKey === keys.celebration"
                  :key="keys.celebration"
                  class="full-width text-left"
                >
                  <Typography variant="h-4" v-if="pageTitle" class="py-6">{{
                    pageTitle
                  }}</Typography>
                  <div v-if="!recognitionMode">
                    <RewardSelector
                      customInputTitle="Payment"
                      paymentLanguage="Payment"
                      paymentIcon="mdi-cash-multiple"
                      ref="reward-selector"
                      :reviewPage="true"
                      :loading="loading.presets"
                      :cashAward="cashAward"
                      :presets="data.presets"
                      :emoji="values.rewardEmoji"
                      :customEmoji="values.rewardEmoji"
                      :amount="values.rewardAmount"
                      :customAmount="values.rewardAmount ? values.rewardAmount.toString() : null"
                      :showBudgetSelector="true"
                      :showCustomRewardSelector="true"
                      :budgetId="values.budgetId"
                      :budgets="visibleBudgets"
                      :loadingBudgets="loadingBudgetsComputed"
                      @select-reward="selectPaymentPreset"
                      @select-custom-reward="addCustomPreset"
                      @update-custom-amount="updatePaymentWizardAmount"
                      @update-custom-emoji="values.rewardEmoji = $event"
                      @update-budgetId="values.budgetId = $event"
                      @update-valid-amount="($event) => (form.validAmount = $event)"
                      @clear="clearPaymentPreset"
                      @blur="sendBudgetIdTrigger"
                    />
                    <div class="d-flex align-center py-4">
                      <v-switch
                        v-model="values.suggestUse"
                        hide-details
                        class="my-0 py-0 mx-1"
                        color="brandPrimary"
                      />
                      <span>Define a specific use for this payment</span>
                      <v-tooltip top
                        ><template v-slot:activator="{ on, attrs }"
                          ><v-icon v-on="on" v-bind="attrs" class="ml-3" small
                            >mdi-help-circle-outline</v-icon
                          ></template
                        ><span
                          >Suggesting a use will cause this payment to show as a separate item in
                          the wallet,<br />
                          making it clear which funds are allocated for a given purpose.</span
                        ></v-tooltip
                      >
                    </div>
                    <div
                      class="mx-auto d-flex align-center selected-category category-container full-width mb-5"
                      v-if="values.suggestUse"
                      @click="dialog.categoryDrawer = true"
                    >
                      <v-icon
                        class="side-nav-icons ml-2 mr-2"
                        color="white"
                        :style="{ 'background-color': '#349E03' }"
                        >{{ suggestedUseCategory ? suggestedUseCategory.icon : "mdi-star" }}</v-icon
                      >
                      <div class="d-flex justify-start align-baseline font-weight-bold brand--text">
                        <p class="ml-2 my-auto" v-if="suggestedUseCategory">
                          {{ suggestedUseCategory.label }}
                        </p>
                      </div>
                      <v-icon large class="ml-auto mr-2">mdi-chevron-right</v-icon>
                    </div>
                  </div>
                  <RewardSelector
                    v-if="recognitionMode && (loading.budgets || visibleBudgets.length)"
                    ref="reward-selector"
                    paymentLanguage="Reward"
                    paymentIcon="mdi-gift-outline"
                    :reviewPage="false"
                    :loading="loading.presets"
                    :cashAward="cashAward"
                    :presets="data.presets"
                    :emoji="values.rewardEmoji"
                    :customEmoji="values.customRewardEmoji"
                    :amount="values.rewardAmount"
                    :paymentPresetId="values.rewardPaymentPresetId"
                    :customAmount="values.customRewardAmount"
                    :rewardPresetName="values.rewardPresetName"
                    :showBudgetSelectorInDrawer="true"
                    :budgetId="values.budgetId"
                    :budgets="visibleBudgets"
                    :loadingBudgets="loadingBudgetsComputed"
                    @select-reward="selectPaymentPreset"
                    @select-custom-reward="addCustomPreset"
                    @update-custom-amount="values.customRewardAmount = $event"
                    @update-custom-emoji="values.customRewardEmoji = $event"
                    @update-budgetId="values.budgetId = $event"
                    @clear="clearPaymentPreset"
                    @blur="sendBudgetIdTrigger"
                  />
                  <CelebrationSelector
                    v-if="recognitionMode"
                    ref="gif-selector"
                    :reviewPage="false"
                    :gif="values.gif || values.image"
                    :hasImageSupport="true"
                    @select-gif="selectGif"
                    @select-image="selectImage"
                    @clear="clearGif"
                  />

                  <div class="cursor-pointer mt-6" v-if="loading.values || data.values.length">
                    <v-select
                      outlined
                      multiple
                      chips
                      deletable-chips
                      return-object
                      hide-selected
                      attach
                      :menu-props="{ top: true, offsetY: true }"
                      :loading="loading.values"
                      v-model="values.companyValues"
                      :items="data.values"
                      item-text="displayName"
                      color="brandPrimary"
                      label="Company values"
                      class="full-width"
                      :no-data-text="
                        values.companyValues && values.companyValues.length
                          ? 'No other company values available'
                          : 'No company values available'
                      "
                    />
                  </div>
                </div>
                <div
                  v-else-if="slideKey === keys.schedule"
                  :key="keys.schedule"
                  class="full-width text-left pb-4"
                >
                  <Typography variant="h-4" v-if="pageTitle" class="py-6">{{
                    pageTitle
                  }}</Typography>
                  <div class="d-flex full-width justify-center">
                    <div
                      class="box-border-global rounded schedule-card"
                      :class="{
                        'schedule-card-selected opacity-40': values.frequency == 'DAILY',
                      }"
                      @click="selectFrequency('DAILY')"
                    >
                      Daily
                    </div>
                    <div
                      class="box-border-global rounded schedule-card"
                      :class="{
                        'schedule-card-selected': values.frequency == 'WEEKLY',
                      }"
                      @click="selectFrequency('WEEKLY')"
                    >
                      Weekly
                    </div>
                    <div
                      class="box-border-global rounded schedule-card"
                      :class="{
                        'schedule-card-selected opacity-40': values.frequency == 'MONTHLY',
                      }"
                      @click="selectFrequency('MONTHLY')"
                    >
                      Monthly
                    </div>
                  </div>
                  <Typography variant="h-4" class="pb-6 pt-8">
                    How long do you want it to run? ({{ numberOfPayments }} payment{{
                      numberOfPayments !== 1 ? "s" : ""
                    }})
                  </Typography>
                  <div class="d-flex justify-space-between align-center full-width">
                    <Typography
                      variant="subtitle-1"
                      class="review-page-text mb-0"
                      :class="{ 'text-xs': $vuetify.breakpoint.xs }"
                    >
                      Start:
                    </Typography>
                    <input
                      class="timestamp-input review-page-field"
                      type="datetime-local"
                      v-model="values.sendDate"
                    />
                  </div>
                  <div class="d-flex justify-space-between align-center full-width mt-8">
                    <Typography
                      variant="subtitle-1"
                      class="review-page-text mb-0"
                      :class="{ 'text-xs': $vuetify.breakpoint.xs }"
                    >
                      End:
                    </Typography>
                    <input
                      class="timestamp-input review-page-field"
                      type="datetime-local"
                      v-model="values.endDate"
                    />
                  </div>
                  <Typography
                    variant="subtitle-1"
                    v-if="invalidEndDate"
                    class="red--text text-caption mt-2 text-end"
                  >
                    {{ invalidEndDate }}
                  </Typography>
                  <div class="d-flex align-center mt-6" v-if="cashAward">
                    <v-switch
                      v-model="values.expiration"
                      hide-details
                      class="my-0 py-0 mx-1"
                      color="brandPrimary"
                    />
                    <span>Will these funds expire?</span>
                    <v-tooltip top
                      ><template v-slot:activator="{ on, attrs }"
                        ><v-icon v-on="on" v-bind="attrs" class="ml-3" small
                          >mdi-help-circle-outline</v-icon
                        ></template
                      ><span
                        >Unused funds will expire at the end of each interval and will be returned
                        to the budget. <br />e.g. weekly payments will expire at the end of each
                        week.</span
                      ></v-tooltip
                    >
                  </div>
                </div>
                <div
                  v-else-if="slideKey === keys.review"
                  :key="keys.review"
                  class="full-width text-left pb-4"
                >
                  <div>
                    <Typography variant="h-4" v-if="pageTitle" class="py-6">{{
                      pageTitle
                    }}</Typography>
                    <div class="d-flex mb-1" v-if="!recognitionMode || hasReward">
                      Total reward amount:
                      <v-progress-circular
                        indeterminate
                        :size="20"
                        :width="2"
                        color="brandPrimary"
                        v-if="loading.distinctUsers"
                      ></v-progress-circular>
                      <span v-else class="ml-2 font-weight-bold">{{ formattedTotalPayment }}</span>
                    </div>
                    <div class="d-flex mb-1" v-if="recurringPaymentMode">
                      Total number of
                      {{ values.frequency ? values.frequency.toLowerCase() : "" }}
                      payments:

                      <span class="ml-2 font-weight-bold">{{ numberOfPayments }}</span>
                    </div>
                    <div class="d-flex flex-wrap align-center">
                      <v-icon
                        v-if="!loading.distinctUsers && values.selected.find((x) => x.groupId)"
                        @click="getDistinctUsersFromGroups"
                        class="ml-2 mr-2"
                        color="brandPrimary"
                        >mdi-refresh</v-icon
                      >
                      <v-progress-circular
                        indeterminate
                        :size="20"
                        :width="2"
                        color="brandPrimary"
                        v-if="loading.distinctUsers"
                      ></v-progress-circular>
                      <!-- A refresh Icon that fetches the paymentAudienceCount again -->

                      <span v-else
                        >{{ paymentAudienceCount }} recipient{{
                          paymentAudienceCount == 1 ? "" : "s"
                        }}:</span
                      >
                      <div
                        v-for="user in values.selected"
                        :key="user.userId"
                        :style="{ 'max-width': '100%' }"
                      >
                        <v-chip
                          @click="goToSlide(keys.recipient)"
                          class="ma-1 selected-audience-chip"
                          outlined
                          color="brandPrimary"
                        >
                          <v-icon
                            @click.stop="loadQrCode(user.groupId)"
                            class="mr-1 cursor-pointer"
                            color="grey"
                            v-if="user.groupId && user.groupType === 'List'"
                            >mdi-qrcode</v-icon
                          >
                          <span class="text-truncate black--text">{{ user.displayName }}</span>
                        </v-chip>
                      </div>
                    </div>
                    <div class="red--text mt-4" v-if="!selectedBudget && !recognitionMode">
                      A budget is required
                    </div>
                    <div class="red--text mt-5" v-if="amountRemainingInBudget < 0">
                      Over budget by {{ amountRemainingInBudgetFormatted }}. Please
                      <a
                        @click="dialog.funding = true"
                        v-if="hasBudgetFundingOptions(selectedBudget)"
                        >add more funds</a
                      ><span v-else>add more funds</span>
                      or select a different budget at the bottom.
                    </div>
                    <Typography variant="subtitle-1" class="pb-2 pt-4">Message</Typography>
                    <v-textarea
                      placeholder="Daniel, I am consistently impressed by your patience with every customer interaction that you face. Your ability to create space for their needs to be heard and calm approach to problem solving allow us to remain a trusted partner to our customers."
                      outlined
                      hide-details
                      v-model="values.memo"
                      color="brandPrimary"
                      class="mb-2"
                    ></v-textarea>
                    <div class="mb-5" v-if="recognitionMode">
                      <div class="d-flex align-center pt-6">
                        <Typography variant="subtitle-1">Visibility</Typography>
                        <v-tooltip top
                          ><template v-slot:activator="{ on, attrs }"
                            ><v-icon v-on="on" v-bind="attrs" class="ml-2"
                              >mdi-help-circle-outline</v-icon
                            ></template
                          ><Typography variant="body-2"
                            >A public recognition will be displayed company-wide in the Activity
                            Feed</Typography
                          ></v-tooltip
                        >
                      </div>
                      <v-radio-group row v-model="values.visibility"
                        ><v-radio value="PRIVATE" label="Private" color="brandPrimary"></v-radio
                        ><v-radio value="PUBLIC" label="Public" color="brandPrimary"></v-radio
                      ></v-radio-group>
                    </div>
                    <RewardSelector
                      v-if="hasRewardPreset"
                      :paymentIcon="recognitionMode ? 'mdi-gift-outline' : 'mdi-cash-multiple'"
                      :paymentLanguage="recognitionMode ? 'Reward' : 'Payment'"
                      ref="reward-selector"
                      :reviewPage="true"
                      :loading="loading.presets"
                      :cashAward="cashAward"
                      :presets="data.presets"
                      :emoji="values.rewardEmoji"
                      :customEmoji="values.customRewardEmoji"
                      :amount="values.rewardAmount"
                      :paymentPresetId="values.rewardPaymentPresetId"
                      :customAmount="values.customRewardAmount"
                      :rewardPresetName="values.rewardPresetName"
                      :showBudgetSelector="true"
                      :showBudgetSelectorInDrawer="true"
                      :showFundBudgetButton="true"
                      :emitEditEvent="!recognitionMode"
                      :budgetId="values.budgetId"
                      :budgets="visibleBudgets"
                      :loadingBudgets="loadingBudgetsComputed"
                      @select-reward="selectPaymentPreset"
                      @select-custom-reward="addCustomPreset"
                      @update-custom-amount="values.customRewardAmount = $event"
                      @update-custom-emoji="values.customRewardEmoji = $event"
                      @update-budgetId="values.budgetId = $event"
                      @edit-custom-reward="goToSlide(keys.celebration)"
                      @fund-budget="dialog.funding = true"
                      @clear="clearPaymentPreset"
                      @blur="sendBudgetIdTrigger"
                    />
                    <CelebrationSelector
                      v-if="values.gif || values.image"
                      ref="gif-selector"
                      :reviewPage="true"
                      :gif="values.gif || values.image"
                      :hasImageSupport="true"
                      @select-gif="selectGif"
                      @select-image="selectImage"
                      @clear="clearGif"
                    />
                    <div class="mb-6" v-if="values.companyValues.length">
                      <v-select
                        outlined
                        multiple
                        chips
                        deletable-chips
                        return-object
                        hide-selected
                        attach
                        :menu-props="{ top: true, offsetY: true }"
                        :loading="loading.values"
                        v-model="values.companyValues"
                        :items="data.values"
                        item-text="displayName"
                        color="brandPrimary"
                        label="Company values"
                        class="full-width"
                        :no-data-text="
                          values.companyValues && values.companyValues.length
                            ? 'No other company values available'
                            : 'No company values available'
                        "
                      />
                    </div>

                    <div
                      v-if="!(recurringPaymentMode && !canEditSenderName)"
                      class="d-flex justify-space-between align-center cursor-pointer user-select-none"
                      @click="dialog.advanced = !dialog.advanced"
                    >
                      <Typography variant="subtitle-1"
                        ><v-icon class="pr-2">mdi-cog</v-icon>Advanced Settings</Typography
                      >
                      <v-icon>mdi-chevron-down</v-icon>
                    </div>
                    <v-expand-transition
                      ><div v-if="dialog.advanced" class="advanced-settings-box px-3 py-3 mt-4">
                        <div
                          v-if="!recurringPaymentMode"
                          class="d-flex justify-space-between align-center full-width"
                        >
                          <p
                            class="review-page-text mb-0"
                            :class="{ 'text-xs': $vuetify.breakpoint.xs }"
                          >
                            Send time:
                          </p>
                          <v-radio-group row v-model="values.sendDateNow" @change="updateSendDate"
                            ><v-radio :value="true" label="Now" color="brandPrimary"></v-radio
                            ><v-radio :value="false" label="Later" color="brandPrimary"></v-radio
                          ></v-radio-group>
                        </div>
                        <div
                          class="d-flex justify-end align-center full-width mt-0"
                          v-if="!values.sendDateNow && !recurringPaymentMode"
                        >
                          <input
                            class="timestamp-input review-page-field"
                            type="datetime-local"
                            v-model="values.sendDate"
                          />
                        </div>

                        <div
                          v-if="!recurringPaymentMode && !recognitionMode && cashAward"
                          class="d-flex justify-space-between align-center full-width"
                        >
                          <div class="d-flex review-page-text1">
                            <p class="mb-0" :class="{ 'text-xs': $vuetify.breakpoint.xs }">
                              Does this expire?
                            </p>
                            <v-tooltip top
                              ><template v-slot:activator="{ on, attrs }"
                                ><v-icon v-on="on" v-bind="attrs" class="ml-3" small
                                  >mdi-help-circle-outline</v-icon
                                ></template
                              ><span
                                >Unused funds will expire on the date you select and will be
                                returned to the budget.
                              </span></v-tooltip
                            >
                          </div>
                          <v-radio-group row v-model="values.expiration" @change="updateEndDate"
                            ><v-radio :value="false" label="No" color="brandPrimary"></v-radio
                            ><v-radio :value="true" label="Yes" color="brandPrimary"></v-radio
                          ></v-radio-group>
                        </div>
                        <div
                          class="d-flex justify-end align-center full-width mt-0"
                          v-if="values.expiration && !recurringPaymentMode && !recognitionMode"
                        >
                          <input
                            class="timestamp-input review-page-field"
                            type="datetime-local"
                            v-model="values.endDate"
                          />
                        </div>
                        <p v-if="invalidEndDate" class="red--text text-caption mt-2 text-end">
                          {{ invalidEndDate }}
                        </p>

                        <div
                          class="d-flex justify-space-between align-start full-width mt-5"
                          v-if="canEditSenderName"
                        >
                          <p
                            class="review-page-text mt-0 pt-2 mb-0"
                            :class="{ 'text-xs': $vuetify.breakpoint.xs }"
                          >
                            Sender name:
                          </p>
                          <v-text-field
                            v-model="values.senderName"
                            label="Name"
                            outlined
                            flat
                            dense
                            color="brandPrimary"
                            class="review-page-field"
                            :rules="formRules.stringOptional(75)"
                          ></v-text-field>
                        </div>
                        <div
                          v-if="recognitionMode"
                          class="d-flex align-center justify-space-between full-width"
                        >
                          <span>Enable comments & reactions: </span>
                          <v-checkbox
                            v-model="values.commentsReactionsEnabled"
                            color="brandPrimary"
                          />
                        </div></div
                    ></v-expand-transition>
                  </div>
                </div>
                <div
                  v-else-if="slideKey == keys.submitting"
                  :key="keys.submitting"
                  class="full-width text-left"
                >
                  <div>
                    <p class="text-h6 font-weight-bold mb-5 mt-12">Processing...</p>
                    <div class="d-flex flex-column align-center"></div>
                  </div>
                </div>
                <div
                  v-else-if="slideKey == keys.sent"
                  :key="keys.sent"
                  class="full-width text-center pt-12"
                >
                  <p class="text-h6 word-break font-weight-bold mb-3">
                    You just made someone's day better!
                  </p>
                  <!-- <p class="full-width">
                Your payments are being processed. You will be notified once
                completed.
              </p> -->
                  <div class="d-flex justify-center mt-6">
                    <Robin :height="120" :width="140" class="" :loop="false" animation="backflip" />
                  </div>
                  <div class="d-flex justify-center mt-12 mb-5">
                    <v-btn
                      depressed
                      rounded
                      color="brandPrimary"
                      class="white--text"
                      @click="reset"
                      width="95"
                      ><span>Close</span></v-btn
                    >
                  </div>
                </div>
                <div
                  v-else-if="slideKey == keys.error"
                  :key="keys.error"
                  class="full-width text-left pt-12"
                >
                  <p class="text-h6 word-break font-weight-bold mb-3">
                    We had some trouble sending your payment. <br />Please try again later.
                  </p>
                  <CustomerServiceContact layout="stacked" class="pl-4 full-width" />

                  <div class="d-flex justify-center my-5">
                    <v-btn
                      depressed
                      rounded
                      color="brandPrimary"
                      class="white--text mt-4"
                      @click="(slideKey = keys.review), (progressBarValue = 0)"
                      ><v-icon class="mr-1">mdi-chevron-left</v-icon
                      ><span style="margin-top: 1px">Go back</span></v-btn
                    >
                  </div>
                </div>
              </transition>
            </div>
          </v-col>
        </v-row>
        <v-overlay
          v-if="
            dialog.showGroupTypeSelector ||
            dialog.createUser ||
            dialog.categoryDrawer ||
            dialog.funding ||
            dialog.annualRewardPopup
          "
        />
        <!-- User creator widget -->
        <v-navigation-drawer v-model="dialog.createUser" temporary fixed right width="500">
          <UserCreatorWidgetSimple
            v-if="dialog.createUser"
            @close="dialog.createUser = false"
            @get-users="getUsers"
            :clientId="clientId"
            source="RECOGNITION_WIZARD"
          ></UserCreatorWidgetSimple>
        </v-navigation-drawer>
        <!-- Group creator widget -->
        <v-navigation-drawer
          v-model="dialog.showGroupTypeSelector"
          temporary
          fixed
          right
          width="500"
        >
          <GroupTypeSelector
            v-if="dialog.showGroupTypeSelector"
            source="RECOGNITION_WIZARD"
            :version="3"
            :clientId="clientId"
            @close="closeGroupCreator"
            @get-groups="getGroups($event, true)"
          />
        </v-navigation-drawer>

        <!-- Budget funding -->
        <v-navigation-drawer
          v-model="dialog.funding"
          temporary
          fixed
          right
          width="500"
          disable-route-watcher
        >
          <StripePaymentMethodsManager
            v-if="dialog.funding"
            @reset="dialog.funding = false"
            @get-budgets="getBudgets"
            :destinationBudget="selectedBudget"
            :budgets="data.budgets"
            :clientId="clientId"
            source="RECOGNITION_WIZARD"
            :displayBudgetTransfer="false"
          />
        </v-navigation-drawer>
        <!-- payment category -->
        <v-navigation-drawer
          v-if="dialog.categoryDrawer"
          v-model="dialog.categoryDrawer"
          temporary
          fixed
          right
          width="500"
        >
          <v-toolbar dark color="#349E03" rounded="0" class="mb-15" flat>
            <v-toolbar-title>Select a reward category</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="dialog.categoryDrawer = false">
                Close
                <v-icon class="ml-2">mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <div
            class="mx-auto mt-2 d-flex align-center category-container"
            :style="{ 'max-height': '40px', width: '80%' }"
            v-for="(option, index) in data.paymentUseCategories"
            :key="option.label"
            @click="values.suggestedUseCategoryIndex = index"
            @mouseover="values.suggestedUseCategoryPreviewIndex = index"
            @mouseleave="values.suggestedUseCategoryPreviewIndex = null"
          >
            <v-icon
              class="side-nav-icons mr-2"
              color="white"
              :style="{ 'background-color': '#349E03' }"
              >{{ option.icon }}</v-icon
            >
            <div
              class="d-flex justify-start align-baseline category-div font-weight-bold brand--text"
              :class="
                values.suggestedUseCategoryIndex == index ? 'selected-category-background' : ''
              "
            >
              <p class="ml-2 my-auto">{{ option.label }}</p>
            </div>
          </div>
          <p class="mb-2 mt-6 text-body-2 text-left grey--text" :style="{ 'margin-left': '50px' }">
            Category description and restrictions
          </p>
          <v-divider :style="{ 'margin-left': '50px', 'margin-right': '50px' }"></v-divider>
          <p class="mt-2 mx-auto text-body-2" :style="{ width: '80%' }">
            {{ suggestedUseCategoryPreview }}
          </p>
        </v-navigation-drawer>
      </v-card>
    </v-dialog>

    <!-- Error dialog -->
    <v-dialog v-model="dialogError" persistent width="500">
      <v-card rounded="0" class="d-flex justify-center flex-column pa-4">
        <div class="d-flex justify-center align-center mx-0 mb-5">
          <v-icon color="error" x-large class="exit-warning-icon mr-2">mdi-alert</v-icon>
          <v-card-title class="word-break text-left exit-warning-text mx-0 px-0">
            {{ errorHeader || "There was an error sending your recognition" }}
          </v-card-title>
        </div>

        <p v-if="errorText">{{ errorText }}</p>
        <p v-for="user in annualPaymentCapErrorArray" :key="user.userId" class="mb-1">
          {{ user.formattedOutput }}
        </p>
        <CustomerServiceContact layout="stacked" class="full-width" />

        <v-card-actions class="mx-12">
          <!-- <v-btn
            color="primary"
            @click="closeProgramBuilder"
            outlined
            width="130"
            >Don't save</v-btn
          > -->
          <v-btn
            class="mx-auto white--text"
            depressed
            rounded
            color="brandPrimary"
            @click="
              (slideKey = keys.review),
                (dialogError = false),
                (progressBarValue = 0),
                (annualPaymentCapErrorArray = [])
            "
            width="130"
            >Go Back</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <QRViewer
      v-if="dialog.qr"
      :groupId="qr.groupId"
      :clientId="qr.clientId"
      @close="dialog.qr = false"
    />
    <v-dialog v-model="dialog.annualRewardPopup" width="500">
      <PopupDialog
        v-if="dialog.annualRewardPopup"
        icon="mdi-check-circle"
        iconColor="success"
        :centerText="true"
        title="Great, you're all done!"
        subtitle="You can now go back to the previous tab and mark the failed reward as 'resolved'."
        button2Text="Ok"
        button2Width="140"
        @button2="dialog.annualRewardPopup = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import Typing from "@/components/vertex-ai/Typing.vue";
import BudgetService from "@/services/BudgetService";
import TriggerService from "@/services/TriggerService";
import UserService from "@/services/UserService";
import GroupService from "@/services/GroupService";
import WalletService from "@/services/WalletService";
import RecognitionService from "@/services/RecognitionService";
import AiService from "@/services/AiService";
import ContentService from "@/services/ContentService";

import Toolbar from "@/components/generic/Toolbar.vue";
import PillNav from "@/components/PillNav";
import Button from "@/components/generic/Button.vue";
import Typography from "@/components/generic/Typography.vue";
import Robin from "@/components/Robin";
import UserCreatorWidgetSimple from "@/components/people/UserCreatorWidgetSimpleV2.vue";
import QRViewer from "@/components/QR.vue";

import GroupTypeSelector from "@/components/groups/GroupTypeSelector.vue";
import GroupTable from "@/components/data-table/Groups.vue";
import UserTable from "@/components/data-table/Users.vue";
import StripePaymentMethodsManager from "@/components/stripe/StripePaymentMethodsManager.vue";
import PopupDialog from "@/components/PopupDialog";
import LottiePlayer from "@/components/LottiePlayer.vue";
import RewardSelector from "@/components/recognition/RewardSelector/RewardSelector.vue";
import CelebrationSelector from "@/components/recognition/CelebrationSelector/CelebrationSelector.vue";

// Mixins
import rewardAmountMixin from "@/mixins/rewardAmountMixin";
import isOne10PointsEnabled from "@/mixins/one10Points/isOne10PointsEnabled";
import isRecognitionsEnabled from "@/mixins/isRecognitionsEnabled";
import budgetFundingMixin from "@/mixins/budgetFundingMixin";

import currency from "currency.js";
import moment from "moment";
import { mapState } from "vuex";
import { debounce } from "@/shared_data/functions";
import { formRules, paymentUseCategories } from "@/shared_data/data";
import CustomerServiceContact from "@/components/help/CustomerServiceContact";

function initialState() {
  return {
    slideKey: 1,
    dialogError: false,
    errorText: null,
    errorHeader: null,
    annualPaymentCapErrorArray: [],
    slideDirection: "topic-left",
    keys: {
      recipient: 1,
      // payment: 2,
      memo: 2,
      celebration: 3,
      schedule: 4,
      review: 5,
      submitting: 6,
      // send: 101,
      sent: 102,
      error: 103,
    },
    loading: {
      submitting: false,
      users: false,
      groups: false,
      groupAssignments: false,
      distinctUsers: false,
      recent: false,
      budgets: false,
      presets: false,
      values: false,
      feedback: false,
      suggestion: false,
    },
    feedback: {
      vibe: {
        behavior: false,
        feeling: false,
        impact: false,
      },
      recommendation: null,
      initialLoad: true, // starts as true so it immediately disables the feedback until we fetch the vibe once
    },
    lottie: {
      particle: false,
    },
    form: {
      validAmount: false,
    },
    data: {
      search: null,
      debounceSearch: null,
      activeAudienceTab: 1,
      users: [],
      groups: [],
      budgets: [],
      presets: [],
      values: [],
      parentPaymentRules: [],
      expirationOptions: [
        { id: 1, label: "Never" },
        { id: 2, label: "1 Week" },
        { id: 3, label: "1 Month" },
        { id: 4, label: "3 Months" },
        { id: 5, label: "6 Months" },
        { id: 6, label: "1 Year" },
        { id: 7, label: "Other" },
      ],
      recurringOptions: [
        { id: 1, label: "Nope, just one time" },
        { id: 2, label: "Weekly" },
        { id: 3, label: "Monthly" },
        { id: 4, label: "Quarterly" },
        { id: 5, label: "Annually" },
      ],
      paymentUseCategories,
    },
    dialog: {
      previewAudience: false,
      selectedAudience: {},
      createGroup: false,
      createUser: false,
      categoryDrawer: false,
      funding: false,
      celebrations: false,
      reward: false,
      companyValue: false,
      annualRewardPopup: false,
      showGroupTypeSelector: false,
      showCreateSimpleGroup: false,
      showCreateQrGroup: false,
      qr: false,
      advanced: false,
    },

    values: {
      budgetId: null,
      selected: [],
      distinctUsers: 0,
      paymentPresetId: null,
      preset: null,
      amount: null,
      customAmount: null,
      totalAmount: null,
      classification: null,
      name: null,
      memo: null,
      visibility: null, // "PUBLIC",
      sendDate: null, //moment().format("YYYY-MM-DDTHH:mm"),
      sendDateNow: true,
      endDate: null,
      expiration: false,
      expirationCustom: null,
      recurring: 1,
      recurringNum: "1",
      categoryIndex: 0,
      gif: null,
      image: null,
      imageFile: null,
      rewardEmoji: null,
      rewardAmount: null,
      rewardPaymentPresetId: null,
      rewardPresetName: null,
      customRewardEmoji: null, //"💰",
      customRewardAmount: null,
      companyValues: [],
      senderName: null,
      suggestUse: false,
      suggestedUseCategoryIndex: 0,
      suggestedUseCategoryPreviewIndex: 0,
      frequency: null,
      commentsReactionsEnabled: true,
    },
    rules: {
      amount: [
        (v) => !!(v && parseFloat(v) > 0) || "Amount must be greater than 0",
        (v) =>
          !!(
            v &&
            (!v.toString().includes(".") ||
              (v.toString().includes(".") &&
                v.toString().substring(v.toString().indexOf(".") + 1).length < 3))
          ) || `Amount shouldn't be longer than 2 decimals.`,
      ],
      recurring: [
        (v) => !!(v && parseFloat(v) > 0) || "# of payments must be greater than 0",
        (v) => !!(v && !v.toString().includes(".")) || "# of payments must be a whole number",
      ],
    },
    formRules,
    progressBarValue: 0,
    budgetPlatformActivityCounter: 0,
    userTable: {
      itemsPerPage: 10,
      page: 1,
      // Used if the user ends up mashing the table page button, then we're waiting on multiple responses so we know which page to actually store the data for
      awaitingPage: 1,
      search: null,
      debounceSearch: null,
      loading: false,
      users: [],
      total: 0,
      selected: [],
      options: {},
      footerProps: {
        "items-per-page-options": [10, 25, 50, 100],
      },
      latestFilter: null,
      latestSort: null,
      columns: [
        { text: "Name", value: "displayName", width: "40%" },
        { text: "Email", value: "businessEmail", width: "50%" },
        { text: "", value: "add" },
      ],
    },
    qr: {
      groupId: null,
      clientId: null,
    },
  };
}

export default {
  name: "RecognitionWizard",
  /**
   * Function form so the page name tracks the wizard's mode. titleMixin
   * composes the brand half, so this returns the page name only.
   */
  title() {
    if (this.recognitionMode) return "Recognition Wizard";
    if (this.recurringPaymentMode) return "Recurring Payment Wizard";
    return "Payment Wizard";
  },
  components: {
    CustomerServiceContact,
    Toolbar,
    Button,
    Typing,
    Typography,
    Robin,
    UserCreatorWidgetSimple,
    GroupTypeSelector,
    GroupTable,
    UserTable,
    StripePaymentMethodsManager,
    LottiePlayer,
    PillNav,
    RewardSelector,
    CelebrationSelector,
    PopupDialog,
    QRViewer,
  },
  mixins: [rewardAmountMixin, isOne10PointsEnabled, isRecognitionsEnabled, budgetFundingMixin],
  props: {
    budgets: Array,
    loadingBudgets: Boolean,
    previousRoute: {
      type: String,
      default: "activity",
    },
    previousRouteProps: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return initialState();
  },
  created() {
    if (this.recognitionMode && !this.isRecognitionsEnabled()) {
      this.$router.replace("/");
      return;
    }

    if (this.$route.query.group == 1) this.data.activeAudienceTab = 2;
    if (this.$route.query.memo) this.values.memo = this.$route.query.memo;
    if (this.$route.query.amount) this.values.rewardAmount = Number(this.$route.query.amount);
    if (this.$route.query.emoji) this.values.rewardEmoji = this.$route.query.emoji;
    if (this.$route.query.visibility) this.values.visibility = this.$route.query.visibility;
    if (this.$route.query.mediaUrl) this.values.gif = this.$route.query.mediaUrl;
    if (this.$route.query.userId) this.getCreatedUsers(this.$route.query.userId);

    this.getCompanyValues();
    this.getPaymentPresets();

    if (!this.budgets) this.getBudgets();

    this.createPlatformActivity(
      this.recognitionMode ? "OPENED_RECOGNITION_WIZARD" : "OPENED_PAYMENT_WIZARD"
    );

    if (this.recurringPaymentMode) {
      this.values.sendDateNow = false;
      this.values.sendDate = moment().format("YYYY-MM-DDTHH:mm");
      this.values.endDate = moment().add(1, "week").format("YYYY-MM-DDTHH:mm");
    }
  },
  mounted() {
    //Move the fresh works help widget
    var freshworks = document.querySelector("#launcher-frame");
    if (freshworks) {
      freshworks.style.right = "-55px";
      freshworks.style["max-width"] = freshworks.style["min-width"] = "90px";
    }
  },
  unmounted() {
    var freshworks = document.querySelector("#launcher-frame");
    if (freshworks) {
      freshworks.style.right = "22px";
    }
  },
  beforeUnmount() {},
  methods: {
    capitalize(value) {
      if (!value) return "";
      const str = value.toString();
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    closeGroupCreator() {
      this.dialog.createGroup = false;
      this.dialog.showGroupTypeSelector = false;
      this.dialog.showCreateQrGroup = false;
      this.dialog.showCreateSimpleGroup = false;
    },
    displayGroupTypeSelector() {
      this.dialog.createGroup = true;
      this.dialog.showGroupTypeSelector = true;
      this.dialog.showCreateQrGroup = false;
      this.dialog.showCreateSimpleGroup = false;
    },

    formatCurrency(amount, cash = true) {
      return currency(amount).format({ symbol: cash ? "$" : "" });
    },
    resetAllData() {
      // Used to reset the state when the user clicks out of the payments console.
      Object.assign(this.$data, initialState());
    },
    reset() {
      if (this.$route.query.previousRoute)
        this.$router.push({
          name: this.$route.query.previousRoute,
          params: {
            // Tell the last route we're coming from recognition wizard
            previousRoute: "recognitionwizard",
          },
        });
      else if (this.previousRoute)
        this.$router.push({
          name: this.previousRoute,
          params: this.previousRouteProps || {},
        });
      else {
        this.resetAllData();
        this.$router.push("/activity");

        // this.$emit("reset");
      }
    },
    scrollToTop() {
      document.getElementsByClassName("v-dialog v-dialog--active")[0].scrollTop = 0;
    },

    goToSlide(index) {
      // Figures out what step we're going into so we can insert the proper platform activity
      const oldIndex = this.slideKey;
      var platformActivityEvent = null;
      if (this.slideKey == this.keys.recipient) platformActivityEvent = "SELECTED_RECIPIENTS";
      else if (this.slideKey == this.keys.memo) {
        platformActivityEvent = "ADDED_MEMO";
      } else if (this.slideKey == this.keys.celebration)
        platformActivityEvent = "ADDED_CELEBRATION";
      // We have to block if the user has already sent payment
      if (this.slideKey >= 1 && this.slideKey < this.keys.submitting) {
        if (index < this.slideKey) {
          this.slideDirection = "topic-right";
          this.scrollToTop();
          return (this.slideKey = index);
        } else {
          this.slideDirection = "topic-left";
        }

        // We route depending on true's and false's in the computed array
        var foundFalse = false;
        // Index is relative to all. We have to equate it to the index in our current route;
        var routeIndex = this.route.findIndex((x) => x == index);

        // When using goToSlide to jump around, we have to make sure the user has completed all steps prior to the step that they're trying to route to.
        for (var i = 0; i < routeIndex; i++) {
          if (!this.routeValidation[i]) {
            foundFalse = true;
          }
        }

        // If we only found true values in the array, then we didn't find a false and therefore can continue
        if (!foundFalse) {
          this.scrollToTop();
          this.slideKey = index;

          if (oldIndex == this.keys.recipient) this.getDistinctUsersFromGroups();

          // Add a default emoji if it's the payment wizard
          if (
            oldIndex === this.keys.celebration &&
            !this.values.rewardEmoji &&
            this.values.rewardAmount > 0
          ) {
            this.values.rewardEmoji = "💰";
          }

          if (platformActivityEvent) this.createPlatformActivity(platformActivityEvent);
        }
      }
    },
    goToNextSlide() {
      this.slideDirection = "topic-left";
      this.scrollToTop();
      const oldIndex = this.slideKey;

      if (this.slideKey === this.keys.review) {
        //We're on the final slide so show confirmation
        //Or we are editing and the message has already sent, so they can only update the message body
        this.playParticleEffect();
        if (this.recognitionMode) this.createRecognition();
        else this.createPayment();
      } else if (this.slideKey == this.keys.sent) {
        this.reset();
      } else {
        // Figures out what step we're going into so we can insert the proper platform activity
        var platformActivityEvent = null;
        if (this.slideKey == this.keys.recipient) platformActivityEvent = "SELECTED_RECIPIENTS";
        else if (this.slideKey == this.keys.memo) {
          platformActivityEvent = "ADDED_MEMO";
        } else if (this.slideKey == this.keys.celebration)
          platformActivityEvent = "ADDED_CELEBRATION";

        // The route has been established. Now we have to check if they can proceed
        var routeIndex = this.route.findIndex((x) => x == this.slideKey);

        this.playParticleEffect();
        this.slideKey = this.route[routeIndex + 1];

        if (oldIndex == this.keys.recipient) this.getDistinctUsersFromGroups();

        // Add a default emoji if it's the payment wizard
        if (
          oldIndex === this.keys.celebration &&
          !this.values.rewardEmoji &&
          this.values.rewardAmount > 0
        ) {
          this.values.rewardEmoji = "💰";
        }

        if (platformActivityEvent) this.createPlatformActivity(platformActivityEvent);
      }
    },
    goToPreviousSlide() {
      this.slideDirection = "topic-right";
      this.scrollToTop();

      // The route has been established. Now we have to check if they can proceed
      var routeIndex = this.route.findIndex((x) => x == this.slideKey);
      var counter = 1;

      this.slideKey = this.route[routeIndex - counter];
    },
    loadBarSleeper(incr, dur, override = false) {
      setTimeout(() => {
        console.log("Incrementing progress", this.progressBarValue);
        if (!this.loading.submitting || override) {
          // We just want to skip to the end
          this.progressBarValue = 100;
        } else {
          this.progressBarValue += incr;
          // We loop IF no error has occurred
          if (this.progressBarValue < 90 && this.slideKey != this.keys.error && !this.dialogError)
            this.loadBarSleeper(incr, dur);
        }
      }, dur);
    },
    refreshClientId(clientId) {
      this.slideKey = this.keys.recipient;
      this.values.budgetId = null;
      this.values.selected = [];

      // We emit this so the parent (Payment Admin will refresh budgets)
      this.$emit("update-client", clientId);
      this.getBudgets();
      this.getCompanyValues();
      this.getPaymentPresets();
    },
    preloadBudget() {
      // Preload the master budget
      if (this.values.budgetId) return;
      const clientBudgets = (this.budgets || this.data.budgets).filter(
        (x) =>
          x.clientId == this.clientId &&
          // x.awardId == 1 &&
          x.status == "Active" &&
          Number(x.budgetBalance) > 0
      );

      console.log("preloadBudget", this.$route.query.budgetId);
      if (this.$route.query.budgetId) {
        const queryBudget = clientBudgets.find((x) => x.budgetId == this.$route.query.budgetId);
        console.log("preloadBudget", queryBudget);
        if (queryBudget) return (this.values.budgetId = queryBudget.budgetId);
      }

      // Prioritize points if the client has one10PointsEnabled
      if (this.isOne10PointsEnabled(this.clientId)) {
        const pointsBudget = clientBudgets.find((x) => x.Award && x.Award.cashValuePoints);
        if (pointsBudget) {
          this.values.budgetId = pointsBudget.budgetId;
          return;
        }
      }

      const acctBalance = clientBudgets.find((x) => x.masterBudget);
      const cashBudget = clientBudgets.find((x) => x.awardId == 1);
      if (acctBalance) this.values.budgetId = acctBalance.budgetId;
      else if (cashBudget) this.values.budgetId = cashBudget.budgetId;
      else if (clientBudgets.length) this.values.budgetId = clientBudgets[0].budgetId;
    },
    createPlatformActivity(event) {
      var obj = {
        userId: this.userProfile.userId,
        clientId: this.userProfile.clientId,
        event: event,
        source: this.recognitionMode ? "RECOGNITION_WIZARD" : "PAYMENTS_WIZARD",
        category: "PAYMENTS",
        date: new Date(),
      };
      TriggerService.createActivity(obj, this.magicLinkToken)
        .then((response) => {
          console.log("Response from inserting activity ", response);
        })
        .catch((error) => {
          console.log("There was an error inserting activity ", error);
        });
    },
    sendBudgetIdTrigger() {
      // We want to fire off a platform activity for when they update the payment memo, but this can be done on any screen.
      // So this gets called when the payment memo field loses focus
      // We also want to make sure this only gets sent once.
      if (this.values.budgetId && this.budgetPlatformActivityCounter == 0) {
        this.createPlatformActivity("SELECTED_BUDGET_WIZARD_BUDGET");
        this.budgetPlatformActivityCounter++;
      }
    },
    changeAudienceTab(newIndex) {
      if (newIndex == this.data.activeAudienceTab) return;
      // const oldTab = this.data.activeAudienceTab;
      // const oldSearchValue = this.data.search;
      this.data.activeAudienceTab = newIndex;
      // this.data.activeAudienceTab = newIndex;

      this.data.debounceSearch = null;
      this.data.search = null;
      // for some reason, if we change the tab, the user table's options don't initialize until you interact with the table once. But if you set the page to 2 then it forces it to init????
      if (this.userTable.options && !this.userTable.options.itemsPerPage) {
        this.userTable.options.page = 2;
        console.log("Setting new page val");
      }

      // If we're leaving users and there was a search value, we refetch users
      // if (oldTab == 1 && oldSearchValue) this.getUsersV2New(true);
    },
    changeSearchTab() {
      console.log("Focused on search bar");
      if (this.data.activeAudienceTab == 0) this.data.activeAudienceTab = 1;
      // for some reason, if we change the tab, the user table's options don't initialize until you interact with the table once. But if you set the page to 2 then it forces it to init????
      if (this.userTable.options && !this.userTable.options.itemsPerPage)
        this.userTable.options.page = 2;
    },
    async getBudgets() {
      try {
        this.loading.budgets = true;
        const clientId = this.clientId;
        let response = await BudgetService.getBudgets(
          {
            lite: 1,
            clientId,
          },
          2,
          this.magicLinkToken
        );
        if (clientId != this.clientId)
          return console.log("Ignoring budget response due to client change");
        console.log("Get budgets ", response);
        this.data.budgets = response;
        this.preloadBudget();
      } catch (e) {
        console.log("Error getting budgets ", e);
      } finally {
        this.loading.budgets = false;
        if (!this.data.budgets.length || !this.data.budgets.find((x) => x.budgetBalance > 0)) {
          this.values.rewardAmount = null;
          this.values.rewardEmoji = null;
          this.values.rewardPresetName = null;
          this.values.rewardPaymentPresetId = null;
        }
      }
    },
    async getCreatedUsers(userId) {
      try {
        this.loading.users = true;
        let filter = `status != 'Deleted' && clientId=${this.clientId}`;
        if (userId) filter += ` && userId = '${userId}'`;
        let limit = 1;
        let offset = 0;
        let sort = "createDate DESC";
        const options = {
          filter: filter,
          limit: limit,
          sort: sort,
          offset: offset,
        };

        // console.log(options);

        let response = await UserService.getUsersV2(options, this.magicLinkToken);
        // console.log("RESPONSE");
        // console.log(response);
        console.log("GOT RESPONSE AFTER FETCHING NEW USER ", response);
        const newUser = response.result.rows[0];
        if (!newUser) return console.log("No user found");
        newUser.display = true;
        this.data.users.push(newUser);
        // We have to find the index to put this user and drop them in there.
        this.data.users = this.data.users.sort((a, b) => {
          const firstNameCompare = a.firstName.localeCompare(b.firstName);
          if (firstNameCompare == 0) {
            return a.lastName.localeCompare(b.lastName);
          } else return firstNameCompare;
        });

        this.loading.users = false;
        this.addUserToSelected(newUser);
      } catch (error) {
        console.log(error);
        this.loading.users = false;
      }
    },
    getGroups(groupId, wipeSearch = false) {
      // Uses the group table widget
      console.log("getGroups", { groupId, wipeSearch });
      if (wipeSearch) {
        this.data.search = undefined;
        this.data.debounceSearch = undefined;
      }
      this.$nextTick(() => {
        if (this.$refs["group-table"])
          this.$refs["group-table"].getGroups(true, "getGroups - recognition wizard", groupId);
      });
    },
    getUsers(userId) {
      // Uses the group table widget
      if (this.$refs["user-table"])
        this.$refs["user-table"].getUsers(true, "getUsers - budget wizard", userId);
    },
    async getPaymentPresets() {
      try {
        this.loading.presets = true;
        const clientId = this.clientId;
        let results = await WalletService.getRecognitionPaymentPresetsV2(
          clientId,
          this.recognitionMode ? "recognition-wizard" : "payment-wizard",
          this.magicLinkToken
        );
        if (clientId != this.clientId)
          return console.log("Ignoring preset response due to client change");
        console.log("Got payment presets ", results.result.rows);
        this.data.presets = results.result.rows.filter((x) => x.status != "Disabled");
      } catch (err) {
        console.log("Error with payment presets ", err);
      } finally {
        this.loading.presets = false;
      }
    },
    async getCompanyValues() {
      if (!this.recognitionMode) return;
      try {
        this.loading.values = true;
        const clientId = this.clientId;
        let results = await RecognitionService.getCompanyValues(
          {
            screen: "recognition-wizard",
            clientId,
          },
          this.magicLinkToken
        );
        if (clientId != this.clientId)
          return console.log("Ignoring company value response due to client change");
        console.log("Got company values ", results.result.rows);
        this.data.values = results.result.rows.filter((x) => x.status != "Disabled");
      } catch (err) {
        console.log("Error with company values ", err);
      } finally {
        this.loading.values = false;
      }
    },
    updateSelectedItem(e) {
      if (!e.groupId) return console.log("no group id");

      this.values.selected.forEach((o) => {
        if (o.groupId == e.groupId) {
          console.log("UPDATING SELECTED NUM USERS ", e.numUsers);
          o.numUsers = e.numUsers || 0;
          // this.getDistinctUsersFromGroups();
        }
      });
    },
    async getDistinctUsersFromGroups() {
      console.log("getDistinctUsersFromGroups()");
      // assign to slidePeople.selectedItem.GroupAssignments
      const groups = this.values.selected.filter((x) => x.groupId).map((x) => x.groupId);
      if (!groups.length) return;
      const users = this.values.selected.filter((x) => x.userId).map((x) => x.userId);
      this.loading.distinctUsers = true;
      try {
        const response = await GroupService.getDistinctUsersFromGroupsV2(
          groups,
          users,
          this.magicLinkToken
        );

        this.values.distinctUsers = response;
        console.log("New distinct user count", this.values.distinctUsers);
      } catch (error) {
        console.log("Error getting distinct number of users ", error);
        this.values.distinctUsers = 0;
      } finally {
        this.loading.distinctUsers = false;
      }
    },
    async addUserToSelected(user, dontRemove = false) {
      console.log("Adding user/group to selected array", user);
      // Added because we can only pass one param in from the groups table
      if (user.dontRemove) dontRemove = true;
      this.dialog.previewAudience = false;
      if (user.userId) {
        let idx = this.values.selected.findIndex((x) => x.userId == user.userId);
        if (idx == -1) this.values.selected.push(user);
        else if (!dontRemove) this.removeUserFromSelected(idx);
      } else {
        let idx = this.values.selected.findIndex((x) => x.groupId == user.groupId);
        if (idx == -1) this.values.selected.push(user);
        else if (!dontRemove) this.removeUserFromSelected(idx);

        // Wipe distinct user count so we have to manually calculate it again rather than using the cached API value
        this.values.distinctUsers = 0;
      }
    },
    removeUserFromSelected(index) {
      // var user = this.values.selected[index];
      this.values.selected.splice(index, 1);

      // Wipe distinct user count so we have to manually calculate it again rather than using the cached API value
      this.values.distinctUsers = 0;
    },
    selectGif(url) {
      this.values.image = null;
      this.values.imageFile = null;
      this.values.gif = url;
    },
    selectImage({ url, file }) {
      this.values.gif = null;
      this.values.image = url;
      this.values.imageFile = file;
    },
    clearGif() {
      this.values.gif = null;
      this.values.gif = null;
      this.values.image = null;
      this.values.imageFile = null;
    },
    selectPaymentPreset(preset) {
      this.values.rewardAmount = preset.amount;
      this.values.rewardEmoji = preset.emoji;
      this.values.rewardPresetName = preset.displayName;
      this.values.rewardPaymentPresetId = preset.paymentPresetId;
    },
    clearPaymentPreset() {
      this.values.rewardEmoji = null;
      this.values.rewardAmount = null;
      this.values.rewardPresetName = null;
      this.values.rewardPaymentPresetId = null;
      this.values.customRewardEmoji = null;

      // leaves review page and goes to celebration page if it's the payment wizard
      if (!this.recognitionMode) {
        this.goToSlide(this.keys.celebration);
      }
    },
    selectCustomEmoji(emoji) {
      this.values.customRewardEmoji = emoji;
    },
    addCustomPreset() {
      if (!this.values.customRewardEmoji) this.values.customRewardEmoji = "💰";
      this.values.rewardEmoji = this.values.customRewardEmoji;
      this.values.rewardAmount = Number(this.values.customRewardAmount);
      this.values.rewardPresetName = null;
      this.values.rewardPaymentPresetId = null;
    },
    updatePaymentWizardAmount(amount) {
      // Reward amount is expecting a number, so we need to convert it
      if (!amount) return (this.values.rewardAmount = null);
      this.values.rewardAmount = currency(amount).value;
    },
    loadCompanyValueDrawer() {
      this.dialog.companyValue = true;
    },
    clearCompanyValue() {
      this.values.companyValues = null;
    },
    selectCompanyValue(value) {
      const existingIndex = this.values.companyValues.findIndex(
        (x) => x.companyValueId == value.companyValueId
      );
      if (existingIndex !== -1) this.values.companyValues.splice(existingIndex, 1);
      else this.values.companyValues.push(value);
      // this.dialog.companyValue = false;
    },
    async createRecognition() {
      // Show loading bar
      this.errorText = this.errorHeader = null;
      console.log("Submitting recognition! ", this.keys.submitting);
      this.slideKey = this.keys.submitting;
      this.loading.submitting = true;
      const progressIncrement = 2;
      const sleepDur = 125;
      this.loadBarSleeper(progressIncrement, sleepDur, false);

      try {
        var mediaUrl = this.values.gif;

        // Handle image file upload if present
        if (this.values.imageFile) {
          try {
            const contentResponse = await ContentService.createPublicContent(
              this.values.imageFile,
              "Recognition",
              this.clientId
            );
            mediaUrl = contentResponse.result;
          } catch (error) {
            console.error("Error uploading image:", error);
            this.dialogError = true;
            if (error.error_code === "1160168") {
              this.errorText = "Image file is too large. Maximum size allowed is 20MB.";
            } else {
              this.errorText = "Failed to upload image. Please try again.";
            }
            return;
          }
        }

        let amt = null;
        if (this.values.rewardAmount) {
          amt = this.convertedRewardAmount;
        }

        var object = {
          clientId: this.clientId,
          budgetId: this.values.budgetId,
          memo: this.computedNote,
          amount: amt ? currency(amt) : null,
          emoji: this.values.rewardEmoji,
          paymentPresetId: this.values.rewardPaymentPresetId,
          visibility: this.values.visibility,
          audience: {
            userId: this.values.selected.filter((x) => x.userId).map((x) => x.userId),
            groupId: this.values.selected.filter((x) => x.groupId).map((x) => x.groupId),
          },
          source: "RECOGNITION_WIZARD",
          mediaUrl,
          mediaType: this.values.gif ? "gif" : mediaUrl ? "image" : null,
          companyValues: this.values.companyValues,
          celebrationId: 1,
          senderName: this.values.senderName,
          commentsReactionsEnabled: this.values.commentsReactionsEnabled,
        };

        if (!this.values.sendDateNow)
          object.sendDate = moment(this.values.sendDate).utc().format("YYYY-MM-DD HH:mm:ssZ");

        if (!object.budgetId && object.emoji) {
          console.log("Wiping reward due to no budget");
          object.amount = null;
          object.emoji = null;
        }
        console.log(object);
        // Display loading screen
        // var response;
        var response = await RecognitionService.createRecognition(object, this.magicLinkToken);
        this.loading.submitting = false;
        this.loadBarSleeper(progressIncrement, sleepDur, true);
        console.log(response);
        if (typeof response == "string") {
          if (response.startsWith("The sum of all payouts")) {
            this.dialogError = true;
            this.errorText = "The total payment sum is more than the selected budget's balance.";
          }
        } else if (response.error) {
          this.slideKey = this.keys.error;
        } else {
          // Display success screen
          this.slideKey = this.keys.sent;

          if (this.$route.query.sourcePage == "annualrewardwizard")
            this.dialog.annualRewardPopup = true;
        }
        // })
      } catch (error) {
        console.log("Error sending recognition! ", error);
        if (error && error.error_code && typeof error.error_code == "string") {
          if (error.error_code.endsWith("0100")) {
            this.dialogError = true;
            this.errorHeader = "The budget does not have enough funds";
            this.errorText =
              "The total reward amount is more than what's available in this budget. Please add more funds or use a different budget.";
            return;
          } else if (error.error_code == "1070127" || error.error_code == "1070128") {
            this.dialogError = true;
            if (error.error_code == "1070127")
              this.errorHeader = "The users below cannot receive any more payments for the year.";
            else
              this.errorHeader =
                "The users below cannot receive the full payment. The amounts each user is capped at are listed below.";
            this.errorText = null;
            this.annualPaymentCapErrorArray = error.data || [];
            return;
          }
        } else if (error && error.error) {
          this.slideKey = this.keys.error;
          return;
        }
        this.dialogError = true;
        this.errorText =
          "An unknown error occurred. Please try again and contact us if this issue persists.";
      }
    },
    async createPayment() {
      // Show loading bar
      this.errorText = this.errorHeader = null;
      console.log("Submitting payment! ", this.keys.submitting);
      this.slideKey = this.keys.submitting;
      this.loading.submitting = true;
      const progressIncrement = 2;
      const sleepDur = 125;
      this.loadBarSleeper(progressIncrement, sleepDur, false);

      try {
        var object = {
          clientId: this.clientId,
          budgetId: this.values.budgetId,
          description: this.computedNote,
          amount: this.values.rewardAmount ? currency(this.values.rewardAmount) : null,
          emoji: this.values.rewardEmoji,
          paymentPresetId: this.values.rewardPaymentPresetId,
          audience: {
            userId: this.values.selected.filter((x) => x.userId).map((x) => x.userId),
            groupId: this.values.selected.filter((x) => x.groupId).map((x) => x.groupId),
          },
          source: "PAYMENTS_WIZARD",
          senderName: this.values.senderName,
          clawback: !!(
            !this.recognitionMode &&
            this.paymentType == "PROVISIONAL" &&
            this.values.expiration &&
            // We need it to be a cash award in order to expire
            this.cashAward
          ),
          frequency: this.recurringPaymentMode ? this.values.frequency : "ONE_TIME",
          // clawback: false,
          paymentType: this.paymentType,
          classification:
            this.values.suggestUse && this.suggestedUseCategory
              ? this.suggestedUseCategory.label
              : this.paymentType,
        };

        if (!this.values.sendDateNow)
          object.startDate = moment(this.values.sendDate).utc().format("YYYY-MM-DD HH:mm:ssZ");

        if (this.values.endDate && (object.clawback || this.recurringPaymentMode))
          object.endDate = moment(this.values.endDate).utc().format("YYYY-MM-DD HH:mm:ssZ");

        console.log(object);
        // Display loading screen
        // var response;
        var response = await WalletService.createPaymentV2(object, this.magicLinkToken);
        this.loading.submitting = false;
        this.loadBarSleeper(progressIncrement, sleepDur, true);
        console.log(response);
        if (typeof response == "string") {
          if (response.startsWith("The sum of all payouts")) {
            this.dialogError = true;
            this.errorText = "The total payment sum is more than the selected budget's balance.";
          }
        } else if (response.error) {
          this.slideKey = this.keys.error;
        } else {
          // Display success screen
          this.slideKey = this.keys.sent;

          if (this.$route.query.sourcePage == "annualrewardwizard")
            this.dialog.annualRewardPopup = true;
        }
        // })
      } catch (error) {
        console.log("Error sending payment! ", error);
        if (error && error.error_code && typeof error.error_code == "string") {
          if (error.error_code.endsWith("0100")) {
            this.dialogError = true;
            this.errorHeader = "The budget does not have enough funds";
            this.errorText =
              "The total reward amount is more than what's available in this budget. Please add more funds or use a different budget.";
            return;
          } else if (error.error_code == "1070127" || error.error_code == "1070128") {
            this.dialogError = true;
            if (error.error_code == "1070127")
              this.errorHeader = "The users below cannot receive any more payments for the year.";
            else
              this.errorHeader =
                "The users below cannot receive the full payment. The amounts each user is capped at are listed below.";
            this.errorText = null;
            this.annualPaymentCapErrorArray = error.data || [];
            return;
          }
        } else if (error && error.error) {
          this.slideKey = this.keys.error;
          return;
        }
        this.dialogError = true;
        this.errorText =
          "An unknown error occurred. Please try again and contact us if this issue persists.";
      }
    },
    updateSendDate() {
      const val = this.values.sendDateNow;
      // console.log("New toggle value ", val);
      if (val) this.values.sendDate = null;
      else this.values.sendDate = moment().format("YYYY-MM-DDTHH:mm");
    },
    updateEndDate() {
      const val = this.values.endDate;
      // console.log("New toggle value ", val);
      if (val) this.values.endDate = null;
      else
        this.values.endDate = moment()
          .add(1, "month")
          .subtract(1, "minute")
          .format("YYYY-MM-DDTHH:mm");
    },
    playParticleEffect() {
      this.lottie.particle = true;
      setTimeout(() => {
        this.lottie.particle = false;
      }, 1000);
    },
    async updateFeedback() {
      this.feedback.initialLoad = false;
      // this.feedback.recommendation = null;
      // If they have nothing, we just wipe it all
      if (!this.computedNote)
        return (this.feedback.vibe = {
          behavior: false,
          feeling: false,
          impact: false,
        });
      this.loading.feedback = true;
      try {
        const data = await AiService.evaluateRecognition(
          {
            recognition: this.computedNote,
          },
          this.magicLinkToken
        );
        console.log("Res:", data);
        // const { data } = r;
        // for (let k of data.vibe) {
        //   console.log("k of data.vibe", k, "of", data.vibe, data.vibe[k]);
        //   this.feedback.vibe[k] = data.vibe[k];
        // }
        Object.assign(this.feedback.vibe, data.vibe);
        // this.feedback.recommendation = data.recommendation;
        console.log({ data }, { feedback: { ...this.feedback } });
      } catch (e) {
        console.log("Error evaluating feedback", e);
      } finally {
        this.loading.feedback = false;
      }
    },
    async aiRecommendation() {
      // this.feedback.state = "waiting";
      this.loading.suggestion = true;
      try {
        const data = await AiService.suggestRecognition(
          {
            recognition: this.computedNote,
            state: {
              data: this.feedback.vibe,
            },
          },
          this.magicLinkToken
        );
        Object.assign(this.feedback.vibe, data.vibe);
        this.feedback.recommendation = data.recommendation;
        console.log({ data }, { feedback: { ...this.feedback } });
        // this.feedback.state = "done";
      } catch (e) {
        console.log("Error recommending feedback", e);
      } finally {
        this.loading.suggestion = false;
      }
    },
    async loadQrCode(groupId) {
      const clientId = Number(
        this.clientId !== undefined && this.clientId !== null
          ? this.clientId
          : this.userProfile.clientId
      );
      this.qr = {
        groupId,
        clientId,
      };
      this.dialog.qr = true;
    },
    selectFrequency(freq) {
      this.values.frequency = freq;
    },
  },
  computed: {
    ...mapState(["userProfile", "permissions", "globalClientId", "magicLinkToken"]),
    clientId: {
      get: function () {
        return this.globalClientId;
      },
      set: function (newVal) {
        this.$store.dispatch("setClientId", newVal);
      },
    },
    disableContinueButton: {
      cache: false,
      get: function () {
        // Compare to route validation
        // We check the index within the route that we're in and use routeValidation to see if we've satisfied the requirements
        var routeIndex = this.route.findIndex((x) => x == this.slideKey);
        return !this.routeValidation[routeIndex];
      },
    },
    visibleBudgets() {
      // var awardId = null;
      const budgetArr = (this.budgets || this.data.budgets).filter((x) => {
        return x.status == "Active" && x.clientId == this.clientId && Number(x.budgetBalance) > 0;
      });
      return budgetArr;
    },
    selectedBudget: {
      cache: false,
      get: function () {
        if (this.values.budgetId !== null) {
          var budget = (this.budgets || this.data.budgets).find(
            (x) => x.budgetId == this.values.budgetId
          );

          return budget;
        }
        return null;
      },
    },
    cashAward() {
      return !(this.selectedBudget && this.selectedBudget.awardId != 1);
    },
    singularAwardUnit() {
      return this.selectedBudget && this.selectedBudget.awardId != 1 && this.selectedBudget.Award
        ? this.selectedBudget.Award.unitSingular || "unit"
        : null;
    },
    pluralAwardUnit() {
      return this.selectedBudget && this.selectedBudget.awardId != 1 && this.selectedBudget.Award
        ? this.selectedBudget.Award.unitPlural || "units"
        : null;
    },
    amountRemainingInBudget() {
      if (this.selectedBudget && this.selectedBudget.budgetBalance) {
        return currency(this.selectedBudget.budgetBalance).subtract(this.totalAmount).value;
      } else {
        return 0;
      }
    },
    amountRemainingInBudgetFormatted() {
      return `${currency(Math.abs(this.amountRemainingInBudget)).format({
        symbol: this.cashAward ? "$" : "",
      })}${
        this.cashAward
          ? ""
          : this.amountRemainingInBudget == 1
          ? ` ${this.singularAwardUnit}`
          : ` ${this.pluralAwardUnit}`
      }`;
    },
    pillNavSteps() {
      return [
        {
          step: this.keys.recipient,
          icon: "account-multiple",
          // active: this.confirmPageReset
        },
        {
          step: this.keys.memo,
          icon: "message-text",
        },
        {
          step: this.keys.celebration,
          icon: "gift-outline",
        },
        this.recurringPaymentMode
          ? {
              step: this.keys.schedule,
              icon: "calendar",
            }
          : undefined,
        {
          step: this.keys.review,
          icon: "rocket-launch",
        },
      ].filter(Boolean);
    },
    route: {
      cache: false,
      get: function () {
        // We establish the route depending on what payment type
        // This dynamic array of keys will be used by routeValidation, disableContinuButton, etc
        return [
          this.keys.recipient,
          this.keys.memo,
          this.keys.celebration,
          this.recurringPaymentMode ? this.keys.schedule : undefined,
          this.keys.review,
          this.keys.submitting,
          this.keys.sent,
        ].filter(Boolean);
      },
    },
    routeValidation: {
      cache: false,
      get: function () {
        var array = [];

        // This uses this.route and compiles an array of true/false values for their entire route to tell us if they've completed everything that they need to
        // Used by disableContinueButton and goToSlide
        this.route.forEach((page) => {
          // Page 1
          // console.log(page);
          if (
            page == this.keys.recipient &&
            this.values.selected.length
            // (this.paymentAudienceCount > 0 ||
            // this.values.selected.find(x => x.groupType == "List"))
          ) {
            array.push(true);
          } else if (
            page == this.keys.celebration &&
            (this.recognitionMode || (this.form.validAmount && this.values.budgetId))
          ) {
            array.push(true);
          } else if (
            page == this.keys.memo &&
            this.values.memo &&
            this.values.memo.length &&
            (!this.recognitionMode || this.values.visibility)
          ) {
            array.push(true);
          } else if (
            page == this.keys.schedule &&
            this.values.frequency &&
            this.values.sendDate &&
            this.values.endDate &&
            !this.invalidEndDate
          ) {
            array.push(true);
          } else if (
            page == this.keys.review &&
            this.values.memo &&
            this.values.memo.length &&
            // Added so they don't accidentally submit if they're over budget
            !this.loading.distinctUsers &&
            // Must have someone in the group
            this.paymentAudienceCount &&
            this.amountRemainingInBudget >= 0 &&
            (!this.values.senderName ||
              (this.values.senderName && this.values.senderName.length < 75)) &&
            (this.recognitionMode || this.hasReward) &&
            // No reward is set or a reward is set with budget
            ((this.recognitionMode && !this.hasRewardPreset) ||
              (this.recognitionMode && this.hasRewardPreset && this.selectedBudget) ||
              (!this.recognitionMode && this.hasReward && this.selectedBudget)) &&
            (this.recognitionMode ||
              this.recurringPaymentMode ||
              !this.cashAward ||
              !this.values.expiration ||
              (this.values.expiration && !this.invalidEndDate))
          ) {
            array.push(true);
          } else if (page == this.keys.submitting) {
            array.push(false);
          } else if (page == this.keys.sent) {
            // console.log("sent");
            array.push(true);
          } else {
            // console.log("ELSE");
            array.push(false);
          }
          // console.log(array[array.length - 1]);
        });

        // console.log(array);
        return array;
      },
    },
    invalidEndDate() {
      if (!this.values.endDate) return null;

      let startDate = this.values.sendDateNow
        ? moment()
        : this.values.sendDate
        ? moment(this.values.sendDate)
        : undefined;
      if (!startDate) return null;
      let endDate = moment(this.values.endDate);

      console.log({ startDate, endDate });

      // Validation above does check to make sure start and dates are defined. Now we make sure end date is after start date
      if (!moment(startDate).isValid()) return "The start date must be a valid date";
      else if (!endDate.isValid()) return "The end date must be a valid date";
      else if (moment(startDate).isSameOrAfter(endDate))
        return `The ${
          this.recurringPaymentMode ? "end" : "expiration"
        } date must be after the start date`;

      // We made it to validity!
      return false;
    },
    loadingBudgetsComputed() {
      if (this.budgets) return this.loadingBudgets;
      return this.loading.budgets;
    },
    computedNote() {
      if (!this.values.memo) return null;
      if (typeof this.values.memo != "string") return null;

      // let arr = [];
      // if (this.values.memo) {
      //   this.values.memo
      //     .split("\n")
      //     .forEach(item => arr.push(`${item.trim()}<br />`));
      // }
      // return arr.join("");
      // We gotta trim it of spaces
      return this.values.memo.trim();
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
    audienceHeaders() {
      if (this.data.activeAudienceTab == 2) {
        return [
          {
            align: "start",
            sortable: false,
            value: "select",
            width: "35px",
          },
          {
            align: "start",
            sortable: true,
            value: "groupDisplayName",
          },
          {
            align: "start",
            sortable: true,
            value: "numUsers",
            width: "50%",
          },

          {
            value: "info",
            width: "100px",
            align: "end",
            sortable: false,
          },
        ];
      }

      return [
        {
          align: "start",
          sortable: false,
          value: "select",
          width: "35px",
        },

        {
          align: "start",
          sortable: true,
          value: "displayName",
          width: "90%",
        },
        {
          align: " d-none",
          sortable: true,
          value: "businessEmail",
          width: "0%",
        },
        {
          align: " d-none",
          sortable: true,
          value: "businessPhone",
          width: "0%",
        },
        {
          value: "info",
          width: "10%",
          align: "end",
          sortable: false,
        },
      ];
    },
    paymentAudienceCount() {
      if (this.loading.distinctUsers && this.values.selected.find((x) => x.groupId)) return 0;
      if (this.values.distinctUsers && this.values.selected.find((x) => x.groupId)) {
        console.log("Returning distinct users ", this.values.distinctUsers);
        return this.values.distinctUsers;
      }
      let count = 0;
      var arr = [];

      this.values.selected.forEach((item) => {
        if (item.groupId && item.numUsers) count += item.numUsers;
        else if (item.groupId && item.GroupAssignments)
          arr = arr.concat(item.GroupAssignments.map((x) => x.userId));
        else if (item.userId) arr.push(item.userId);
      });

      if (count != 0) return count;
      return [...new Set(arr)].length;
    },
    convertedRewardAmount() {
      // This factors in points and converts the dollar value to points if applicable (coming from a preset)
      return this.calculatePresetAmount(
        this.values.rewardAmount,
        this.selectedBudget,
        // Ignore the points if they did a custom amount
        !(this.hasRewardPreset && this.values.rewardPaymentPresetId)
      );
    },
    totalAmount() {
      return currency(this.convertedRewardAmount)
        .multiply(this.paymentAudienceCount)
        .multiply(this.numberOfPayments).value;
    },
    formattedTotalPayment() {
      let v = this.totalAmount;
      return `${currency(v).format({ symbol: this.cashAward ? "$" : "" })} ${
        this.cashAward ? "" : v == 1 ? this.singularAwardUnit : this.pluralAwardUnit
      }`;
    },
    numberOfPayments() {
      if (
        !this.recurringPaymentMode ||
        !this.values.sendDate ||
        !this.values.endDate ||
        !this.values.frequency
      )
        return 1;

      let start = moment(this.values.sendDate).local();
      const end = moment(this.values.endDate).local();
      let numDates = 0;

      if (this.values.frequency == "DAILY") {
        numDates = Math.ceil(moment.duration(end.diff(start) + 1).asDays());
      } else if (this.values.frequency == "WEEKLY") {
        numDates = Math.ceil(moment.duration(end.diff(start) + 1).asWeeks());
      } else {
        numDates++;
        while (moment(end).diff(start, "month") > 0) {
          const currentEnd = moment(moment(start).add(1, "month")).utc();
          numDates++;

          start = currentEnd;
        }
      }
      return numDates;
    },
    selectedGroups: {
      get: function () {
        return this.values.selected.filter((x) => x.groupId);
      },
      set: function () {
        // console.log("Adding el ", o);
      },
    },
    selectedUsers: {
      get: function () {
        return this.values.selected.filter((x) => x.userId);
      },
      set: function () {
        // console.log("Adding el ", o);
      },
    },
    hasReward() {
      return !!this.values.rewardAmount;
    },
    hasRewardPreset() {
      return !!(this.values.rewardEmoji && this.values.rewardAmount);
    },
    canCreateUser() {
      return (this.permissions || []).find((x) => x == "users:create:user");
    },
    canCreateGroup() {
      return (this.permissions || []).find((x) => x == "groups:create:group");
    },
    canEditSenderName() {
      return (this.permissions || []).includes("payment:create:send-as");
    },
    canViewAIAssistant() {
      return (
        this.recognitionMode && (this.permissions || []).includes("vue:read:recognition-assistant")
      );
    },
    recognitionMode() {
      return this.$route.name == "recognitionwizard";
    },
    recurringPaymentMode() {
      return this.$route.name == "recurringpaymentwizard";
    },
    wizardIcon() {
      return this.recognitionMode ? "mdi-party-popper" : "mdi-cash-fast";
    },
    wizardLanguage() {
      return this.recognitionMode
        ? "recognition"
        : this.recurringPaymentMode
        ? "recurring reward"
        : "reward";
    },
    pageTitle() {
      let pageKey = this.slideKey;
      let title;
      switch (pageKey) {
        case this.keys.recipient:
          title = this.recognitionMode
            ? "Who are you recognizing?"
            : "Who is receiving this reward?";
          break;
        case this.keys.memo:
          title = this.recognitionMode ? "Tell them what was special." : "Add a note?";
          break;
        case this.keys.celebration:
          title = this.recognitionMode
            ? "Add some flair to your recognition."
            : "Add some flair to your reward.";
          break;
        case this.keys.schedule:
          title = "How often are you sending this reward?";
          break;
        case this.keys.review:
          title = "Does this look right?";
          break;
      }
      return title;
    },
    suggestedUseCategory() {
      if (this.values.suggestedUseCategoryIndex == null) return;
      return this.data.paymentUseCategories[this.values.suggestedUseCategoryIndex];
    },
    suggestedUseCategoryPreview() {
      // suggestedUseCategoryPreviewIndex
      if (this.values.suggestedUseCategoryPreviewIndex == null) return;
      const category = this.data.paymentUseCategories[this.values.suggestedUseCategoryPreviewIndex];
      return category ? category.description : null;
    },
    paymentType() {
      return ((this.values.suggestUse && this.suggestedUseCategory) || this.values.expiration) &&
        this.cashAward
        ? "PROVISIONAL"
        : "DEFAULT";
    },
  },
  watch: {
    "values.memo": debounce(async function () {
      // alert("w0t");
      if (!this.canViewAIAssistant) return;
      await this.updateFeedback();
      // alert("noway");
    }, 1000),
    budgets: function (newVal, oldVal) {
      if (oldVal.length == 0) {
        console.log("Got budget watcher", oldVal);

        this.preloadBudget();
      }
    },
    clientId: function () {
      this.refreshClientId();
    },
    "data.debounceSearch": debounce(function (newVal) {
      this.data.search = newVal;
    }, 500),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Code for transitions between slides */
.topic-left-enter {
  opacity: 0;
  transform: translateX(100%);
}

.topic-right-enter {
  opacity: 0;
  transform: translateX(-100%);
}

.topic-left-enter-active,
.topic-right-enter-active {
  transition: all 0.65s cubic-bezier(0.19, 1, 0.22, 1);
}

.error-background {
  background-color: var(--v-error-base);
}

.header-text {
  font-size: x-large;
}

.light-grey-background {
  background-color: var(--v-lightGrey-base);
}

.people-group-button {
  padding: 5px 5px;
  border-radius: 7px;
  width: 200px;
  background-color: var(--v-lightGrey-base);
}
.audience-button {
  background-color: white;
  background: white;
  border: 1px solid;
  border-color: var(--v-grey-base);
}
.profile-picture {
  border: 2px solid;
  border-color: var(--v-grey-base);
}
.icon-image {
  height: 105px;
  width: 105px;
}

.text-overflow-clip {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.amount-table {
  padding-top: 1px;
  border: solid 1px;
  border-color: lightgray;
  border-radius: 4px;
}

.amount-table >>> .v-data-table-header {
  background-color: white;
}
.side-nav-bold-text {
  color: var(--v-brand-base);
  font-weight: bold;
}
.side-nav-text {
  color: var(--v-brand-base);
}
.side-nav-icons {
  border-radius: 5px;
  width: 35px;
  min-width: 35px;
  height: 35px;
  min-height: 35px;
}
.side-nav-box {
  width: 100%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 1px solid lightgray;
  border-radius: 5px;
  height: 35px;
  padding-top: 7px;
}
.side-nav-panel {
  width: 100%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding-top: 7px;
}
.budget-select >>> .v-list-item {
  font-size: 0.8125rem;
}
.category-div {
  width: 100%;
  border: 1px solid lightgray;
  border-radius: 5px;
  height: 40px;
  cursor: pointer;
}
.selected-category {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 5px;
  height: 45px;
  cursor: pointer;
}
.category-container {
  cursor: pointer;
}
.category-container:hover .category-div {
  background-color: #e8e8ec;
}
.selected-category-background {
  background-color: #e8e8ec;
}
.timestamp-input {
  margin-top: 0px;
  margin-bottom: 0px;
}
.rounded-border {
  border: 1px solid lightgray;
  border-radius: 5px;
}
.selected-people-content >>> .v-expansion-panel-content__wrap {
  padding-left: 0px;
  padding-right: 0px;
}
.input-error {
  color: var(--v-error-base) !important;
  caret-color: var(--v-error-base) !important;
  border: 2px solid var(--v-error-base) !important;
}

#note {
  background: var(--v-lightGrey-base);
  padding: 10px 10px;
  margin-left: 24px;
  width: calc(100% - 24px);
  border-radius: 6px;
}

/* outline used for the main content card */
.main-card {
  border: solid 1px;
  border-color: lightgray;
  /* min-height: calc(100vh - 120px); */
}

.budget-name-container {
  width: calc(100% - 120px);
}

.progress-bar {
  width: 70%;
  min-width: 220px;
  max-width: 600px;
}

/* progress bar text */
.progress-bar >>> .v-progress-linear__content {
  justify-content: flex-start;
  margin-left: 15px;
}

.progress-bar >>> .v-progress-linear__determinate {
  border-radius: 0 9999px 9999px 0;
}

.progress-bar >>> .v-progress-linear__background {
  left: 0 !important;
  width: 100% !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  display: none;
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

/* Hides extra padding that for some reason exists in v-row */
.container-row {
  overflow-x: hidden;
  min-height: calc(100vh - 100px);
}

/* Provides spacing for each audience tab */
.audience-tab {
  padding: 8px 20px 8px 20px;
}

/* Bkgnd color for selected audience tab */
.active-audience-tab {
  background-color: #e8e8e8 !important;
}

/* Provides feedback when you hover over an audience tab */
.audience-tab:hover {
  background: lightgray;
}

/* Changes the close icon's color for selected audience chips */
.selected-audience-chip >>> .v-chip__close {
  color: lightgray;
}

.preset-loading {
  height: 70px;
}
/* Outer container for row of preset carousel */
.preset-carousel {
  overflow-x: scroll;
}
/* Card for each preset */
.preset-card {
  border: 1px solid lightgray;
  width: 75px;
  min-width: 75px;
  /* background: white !important; */
}

.icon-img {
  width: 70px;
  height: 70px;
}
.preset-card >>> .icon-img {
  width: 50px;
  height: 50px;
}
.preset-card >>> .text {
  font-size: small;
}

/* Sets width for amt field */
.amount-text-field >>> .v-input__slot {
  max-width: 150px;
  width: 150px;
  min-width: 150px;
}

.review-page-field {
  width: 65% !important;
  min-width: 170px !important;
  max-width: 400px !important;
  margin-left: 12px;
}
.review-page-text {
  width: 35% !important;
}
.box-border {
  border: 1px solid lightgray;
}
.box-border-green {
  border-color: var(--v-brandDarkGreen-base);
}
.box-border-cyan {
  border-color: var(--v-brandPrimary-base);
}

.preset-emoji {
  font-size: 40px;
}

/* Thickens the border on audience chips */
.selected-audience-chip.v-chip.v-chip--outlined {
  border-width: 2px !important;
}
.lottie-container {
  position: relative;
}
.lottie-particle-effect {
  position: absolute;
  top: -105px;
  left: -77px;
  /* z-index: 1; */
  pointer-events: none;
}

/* Adds grey hover effect when selecting a payment preset */
.celebration-box:hover {
  background-color: #eeeeee;
}

/* Tile / card for daily/weekly/monthly */
.schedule-card {
  width: 110px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px 0 10px;
  cursor: pointer;
  user-select: none;
}

.schedule-card-selected {
  background-color: #eeeeee;
  border: 2px solid var(--v-brandPrimary-base);
}

.schedule-card:hover {
  background-color: #eeeeee;
}

.advanced-settings-box {
  border-radius: 3px;
  border: 1px solid lightgray;
}
</style>
